module.exports = __webpack_public_path__ + "static/img/vip_privilege1.7b57520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege1.png
// module id = 7uen
// module chunks = 0